/** Teto do envio agendado; o servidor valida o mesmo limite. */
export const TETO_AGENDAMENTO_DIAS = 30;

export interface HorarioPronto {
  rotulo: string;
  quando: Date;
}

/** Os horarios do menu "Agendar envio", no fuso de quem escreve. */
export function horariosProntos(agora = new Date()): HorarioPronto[] {
  const amanha = new Date(agora);
  amanha.setDate(amanha.getDate() + 1);
  amanha.setHours(8, 0, 0, 0);

  // Proxima segunda: se hoje e segunda, a da semana que vem.
  const segunda = new Date(agora);
  segunda.setDate(segunda.getDate() + ((8 - segunda.getDay()) % 7 || 7));
  segunda.setHours(8, 0, 0, 0);

  const horarios = [
    { rotulo: 'Daqui a 1 hora', quando: new Date(agora.getTime() + 3_600_000) },
    { rotulo: 'Amanhã, 8h', quando: amanha },
  ];
  // Aos domingos a segunda e amanha: um item so, sem horario repetido.
  if (segunda.getTime() !== amanha.getTime())
    horarios.push({ rotulo: 'Segunda, 8h', quando: segunda });
  return horarios;
}

/** Falso quando o horario esta no passado (ou a menos de 1 min) ou alem do teto. */
export function horarioValido(quando: Date, agora = new Date()): boolean {
  const ms = quando.getTime() - agora.getTime();
  return ms > 60_000 && ms <= TETO_AGENDAMENTO_DIAS * 86_400_000;
}

/** Valor de um `datetime-local` (hora local, sem fuso) a partir de uma data. */
export function paraCampoLocal(d: Date): string {
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}
